/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compliance_Template_Action_RedactInputs */



/**
* | output |
* | --- |
* | "Create audit log and redact sensitive data" |
*
* @param {Compliance_Template_Action_RedactInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const compliance_template_action_redact = /** @type {((inputs?: Compliance_Template_Action_RedactInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compliance_Template_Action_RedactInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Prüfprotokoll erstellen und sensible Daten schwärzen")
	return /** @type {LocalizedString} */ ("Create audit log and redact sensitive data")
});